
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'Practice',
  props: ['word'],
  emits: ['next'],
  setup(prop, context) {
    const input = ref('');

    const isRight = computed(() => input.value.trim() === prop.word);

    const submit = () => {
      if (isRight.value) {
        input.value = '';
        context.emit('next');
      }
    };

    return {
      input, isRight, submit,
    };
  },
});
